/** @format */

import template from './gb-edit-total-raised-widget.html';

export const GbEditTotalRaisedWidgetComponent = {
    template,
    require: {
        gbEditTools: '^^',
    },
    bindings: {
        widget: '=',
    },
    controller: class GbEditTotalRaisedWidgetComponent {
        constructor() {
            'ngInject';
        }
    },
};
